export interface IStandingTicketsEvents {
  UPDATE_TOTAL: string;
  SELECT_STANDING_TICKET: string;
  REMOVE_TICKET: string;
}

export const STANDING_TICKETS_EVENTS: IStandingTicketsEvents = {
  UPDATE_TOTAL: 'STANDING_TICKETS.UPDATE_TOTAL',
  SELECT_STANDING_TICKET: 'STANDING_TICKETS.SELECT_STANDING_TICKET',
  REMOVE_TICKET: 'STANDING_TICKETS.REMOVE_TICKET',
};
